import { useRoles } from "./use-roles";
import { RolesView } from "./view-roles";

/** Liga o ViewModel à View da aba Perfis. */
export function RolesScreen() {
  const vm = useRoles();

  return <RolesView {...vm} />;
}

export type * from "./types-roles";
